import {ListItemText, Stack, Switch, Typography} from '@mui/material';
import {DecisionModal, IconIllustration} from 'presentation/components';
import {ModalError} from 'presentation/components/ModalError';
import {FeaturesEnum, OperationStateTypesEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {useAccountInformation} from 'presentation/pages/private/hooks';
import {useBusinessToggle} from './hooks/useBusinessToggle';
import {CustomBox} from './styles';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';

const {permissionHolder, permissionDependent, permissionToggle} =
	translations['pt-br'].privateFlow.profile;
const {
	title: modalErrorTitle,
	description: modalErrorDescription,
	tryAgainBtn,
} = translations['pt-br'].others.genericErrorModal;
const {unableToContinue, confirmation, cancel} = translations['pt-br'].commons;
const {
	disableAccessModal: {
		title: disableAccessModalTitle,
		descriptionHolder: disableAccessModalDescriptionHolder,
		descriptionDependent: disableAccessModalDescriptionDependent,
		button: disableAccessModalButton,
	},
} = translations['pt-br'].privateFlow.businessAccessPermission;

export default function BusinessToggle() {
	const {isHolder} = useAccountInformation();
	const {
		businessHasAccessState,
		AUTHORIZE_ACCESS_IS_ERROR,
		handleAuthorizeAccess,
		setOperationScheduleState,
		goToAccessPermissionPage,
		warningDisabledAccessState,
		setWarningDisabledAccessState,
		AUTHORIZE_ACCESS_IS_LOADING,
		retryAuthorizeAccess,
	} = useBusinessToggle();

	const {isEnabled: isNewProfileFeatureFlagEnabled} = useFeatureFlag(
		FeaturesEnum.ADD__PORTAL_FEATURE_NEW_PROFILE,
	);

	return (
		<Fragment>
			<CustomBox
				flexDirection="row"
				justifyContent="space-between"
				alignContent="center"
				p={isNewProfileFeatureFlagEnabled ? 0 : 2}>
				<Stack spacing={2} direction="row" alignItems="center">
					<IconIllustration
						variant="primary"
						customIconName="laptop-chromebook-filled"
						size={isNewProfileFeatureFlagEnabled ? 'small' : 'smaller'}
						sx={{p: isNewProfileFeatureFlagEnabled ? 1 : undefined}}
					/>
					{isNewProfileFeatureFlagEnabled ? (
						<Stack>
							<Typography variant="body1" fontWeight={600} color="text.primary">
								{permissionToggle}
							</Typography>

							<Typography variant="body2" color={'text.secondary'}>
								{isHolder ? permissionHolder : permissionDependent}
							</Typography>
						</Stack>
					) : (
						<ListItemText
							primary={isHolder ? permissionHolder : permissionDependent}
							slotProps={{
								primary: {
									variant: 'body2',
									ml: -1,
									color: 'text.primary',
								},
							}}
						/>
					)}
				</Stack>
				<Switch checked={businessHasAccessState} onChange={goToAccessPermissionPage} />
			</CustomBox>

			{warningDisabledAccessState ? (
				<DecisionModal
					open={warningDisabledAccessState}
					onClose={() => setWarningDisabledAccessState(false)}
					headerTitle={confirmation}
					customIconName="computer-filled"
					title={disableAccessModalTitle}
					isFullScreen={false}
					maxWidth={420}
					description={
						isHolder
							? disableAccessModalDescriptionHolder
							: disableAccessModalDescriptionDependent
					}
					textAlignDescription="left"
					firstButton={{
						title: disableAccessModalButton,
						handleClick: handleAuthorizeAccess,
						variant: 'contained',
						disabled: AUTHORIZE_ACCESS_IS_LOADING,
						isLoading: AUTHORIZE_ACCESS_IS_LOADING,
					}}
					secondButton={{
						title: cancel,
						handleClick: () => setOperationScheduleState(OperationStateTypesEnum.NONE),
						variant: 'outlined',
						disabled: AUTHORIZE_ACCESS_IS_LOADING,
					}}
				/>
			) : null}

			{AUTHORIZE_ACCESS_IS_ERROR ? (
				<ModalError
					open={AUTHORIZE_ACCESS_IS_ERROR}
					onClose={() => setOperationScheduleState(OperationStateTypesEnum.NONE)}
					headerTitle={modalErrorTitle}
					title={unableToContinue}
					isFullScreen={false}
					maxWidth={420}
					description={modalErrorDescription}
					firstButton={{
						title: tryAgainBtn,
						handleClick: retryAuthorizeAccess,
						variant: 'contained',
					}}
				/>
			) : null}
		</Fragment>
	);
}
